import { useTranslation } from "react-i18next";
import defaultContent from "../../../../content/profile";
import "./PrimaryTag.scss";

type Props = {
  isPrimary?: boolean;
};

const PrimaryTag = (props: Props) => {
  const { isPrimary } = props;
  const { t } = useTranslation(["profile"]);

  if (isPrimary === true) {
    return (
      <span className="leaf-primary-tag">{`${t(
        "customerProfile.tags.primary",
        defaultContent["customerProfile"]["tags"]["primary"],
      )}`}</span>
    );
  }
  return <></>;
};

export default PrimaryTag;
